import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { useMutation } from "@tanstack/react-query";
import { deleteData } from "../../utility/superAdminApi";

function ChatDelete({ messageId }) {
  const DeleteMessage = useMutation({
    mutationFn: () => deleteData("/api/superadmin/chats/delete/", messageId),
    onSuccess: () => {
      // Automatically refetches the "cart" query, ensuring the data is correct
      // queryClient.invalidateQueries("notifications");
    },
  });

  const handleDelete = (id) => {
    DeleteMessage.mutate(id);
  };
  return (
    <div>
      <DeleteIcon
        className="text-red-500 cursor-pointer"
        onClick={() => handleDelete(messageId)}
      />
    </div>
  );
}

export default ChatDelete;
